import React from "react";
import { ObjectListValues, SortableListValues } from "../";

export const ObjectListAttachedFiles = (props) => <ObjectListValues {...props} editText="Cambiar archivo" addText="Agregar archivo" SortableList={SortableListValues} />